import { VehicleItemType } from 'constants/enums/vehicleItemType';

/**
 * @description 車險保障內容險種對應文字
 */
export const VehicleItemTypeMatchesText: Readonly<Record<string, string>> = {
  [VehicleItemType.ITEM_TYPE_BD]: '車體險',
  [VehicleItemType.ITEM_TYPE_TF]: '竊盜險',
  [VehicleItemType.ITEM_TYPE_TP]: '第三人責任險',
  [VehicleItemType.ITEM_TYPE_CO]: '強制險'
};
